module.exports = __webpack_public_path__ + "img/radio-empty.64cc7068.svg";